export enum CommentThreadType {
  Comment = 1,
  Suggestion = 2,
}
